// client/src/pages/Weddings/steps/DessertsStep/components/DessertGrid.jsx
import React from "react";
import {
  Grid,
  Box,
  Typography,
  Skeleton,
  Card,
  CardContent,
} from "@mui/material";
import DessertCard from "./DessertCard";

export default function DessertGrid({ loading, visibleItems, selections }) {
  if (loading) {
    return (
      <Grid container spacing={2}>
        {Array.from({ length: 6 }).map((_, i) => (
          <Grid item xs={12} sm={6} key={i}>
            <Card
              variant="outlined"
              sx={{ borderRadius: 3, overflow: "hidden" }}>
              <Skeleton variant="rectangular" height={200} />
              <CardContent>
                <Skeleton width="60%" />
                <Skeleton width="40%" />
                <Skeleton variant="rounded" height={44} sx={{ mt: 1.5 }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!visibleItems.length) {
    return (
      <Box sx={{ py: 6, textAlign: "center", color: "text.secondary" }}>
        <Typography variant="body2">No items in this group yet.</Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {visibleItems.map((it) => (
        <Grid item xs={12} sm={4} key={it._id}>
          <DessertCard it={it} selections={selections} />
        </Grid>
      ))}
    </Grid>
  );
}
